/*
 * @Date: 2021-01-28 09:47:39
 * @LastEditors: 孙强强
 * @LastEditTime: 2021-09-16 11:09:19
 */
import { isAndroid, isIOS, isWeixin, isApp, isMiniprogram } from "./untils";
import {
  anGetlocation,
  anRefreshOrShare,
  anSetRightIcon,
  anCopyText,
  anOpenMin,
  anOpenWx,
  anGetHeaderHeight,
  anSetHeaderStyle,
  anSetBackBtnHide,
  anCheckPushSetting,
  anOpenPushSetting
} from "./android";
import {
  iosGetlocation,
  iosSetTitle,
  iosRefreshOrShare,
  iosSetRightIcon,
  iosCopyText,
  iosOpenMin,
  iosOpenWx,
  iosGetHeaderHeight,
  iosGetPhone,
  iosSharePanel,
  iosWxpayScore,
  iosSetHeaderStyle,
  iosCloseWindow,
  iosSetBackBtnHide,
  iosCheckPushSetting,
  iosOpenPushSetting
} from "./ios";
import weChat from "./wechat";
import Cookies from "js-cookie";
// const wx = require('weixin-js-sdk')
import wx from "weixin-js-sdk";
/**
 * @description: 获取经纬度
 * @param {*} getlocation
 * @return {*}
 */
export const getlocation = async ({ wxName, type } = {}) => {
  let rsp;
  try {
    if (isAndroid) {
      rsp = anGetlocation();
    } else if (isIOS) {
      rsp = iosGetlocation();
    } else if (isWeixin) {
      let w = new weChat(wxName);
      rsp = await w.getLocation({ type });
    }
  } catch (error) {
    rsp = {
      code: -99,
      msg: error,
    };
  }
  console.log(rsp);
  return rsp;
};

/**
 * @description: 使用微信内置地图查看位置
 * @param {*} openLocation
 * @return {*}
 */
export const openLocation = ({
  wxName,
  latitude,
  longitude,
  name,
  address,
  scale,
  infoUrl,
} = {}) => {
  if (isWeixin) {
    let w = new weChat(wxName);
    w.openLocation({ latitude, longitude, name, address, scale, infoUrl });
  }
};

/**
 * @description: 扫一扫
 * @param {*} scanQRCode
 * @return {*}
 */
export const scanQRCode = async ({ wxName, needResult, scanType } = {}) => {
  let rsp;
  try {
    if (isApp) {
      window.location.href = "https://w.cekid.com?cmd=kwqrhome";
    } else if (isWeixin) {
      let w = new weChat(wxName);
      rsp = await w.scanQRCode({ needResult, scanType });
    }
  } catch (error) {
    rsp = {
      code: -99,
      msg: error,
    };
  }
  return rsp;
};

/**
 * @description: 关闭当前页面
 * @param {*} closeWindow
 * @return {*}
 */
export const closeWindow = ({ wxName } = {}) => {
  if (isApp) {
    if (isAndroid) {
      window.localjs.gofinish();
    } else if (isIOS) {
      iosCloseWindow();
    }
  } else if (isWeixin) {
    let w = new weChat(wxName);
    w.closeWindow();
  }
};

/**
 * @description: 批量隐藏功能按钮接口
 * @param {*} hideMenuItems
 * @return {*}
 */
export const hideMenuItems = ({ wxName, itemList } = {}) => {
  if (isWeixin) {
    let w = new weChat(wxName);
    w.hideMenuItems({ itemList });
  }
};
/**
 * @description: 批量显示功能按钮接口
 * @param {*} showMenuItems
 * @return {*}
 */
export const showMenuItems = ({ wxName, itemList } = {}) => {
  if (isWeixin) {
    let w = new weChat(wxName);
    w.showMenuItems({ itemList });
  }
};
/**
 * @description: 隐藏所有非基础按钮接口
 * @param {*} hideAllNonBaseMenuItem
 * @return {*}
 */
export const hideAllNonBaseMenuItem = ({ wxName } = {}) => {
  if (isWeixin) {
    let w = new weChat(wxName);
    w.hideAllNonBaseMenuItem();
  }
};
/**
 * @description: 显示所有功能按钮接口
 * @param {*} showAllNonBaseMenuItem
 * @return {*}
 */
export const showAllNonBaseMenuItem = ({ wxName } = {}) => {
  if (isWeixin) {
    let w = new weChat(wxName);
    w.showAllNonBaseMenuItem();
  }
  /**
   * @description: 设置页面标题
   * @param {*}title 页码标题
   * @return {*}
   */
};
/**
 * @description: 设置页面标题
 * @param {*} setTitle
 * @return {*}
 */
export const setTitle = (title) => {
  if (isIOS) {
    iosSetTitle(title);
  }
  document.title = title || "";
};
/**
 * @description: 设置分享 刷新
 * @param {*} refreshOrShare
 * @return {*}
 */
export const refreshOrShare = ({ refresh, share } = {}) => {
  if (isIOS) {
    iosRefreshOrShare({ refresh, share });
  } else if (isAndroid) {
    anRefreshOrShare({ refresh, share });
  }
};
/**
 * @description: app webview加载完毕
 * @param {*} fn 回调函数
 */
export const onAppReady = (fn) => {
  window.onappload = fn;
};
/**
 * @description: 页面初始化，设置标题，分享及刷新
 * @param {*} setPageInfo
 * @return {*}
 */
export const setPageInfo = ({ title, refresh, share } = {}) => {
  onAppReady(() => {
    setTitle(title);
    isApp && refreshOrShare({ refresh, share });
  });
  window.addEventListener("pageshow", () => {
    setTitle(title);
    isApp && refreshOrShare({ refresh, share });
  });
  setTitle(title);
  isApp && refreshOrShare({ refresh, share });
  setTimeout(() => {
    setTitle(title);
    isApp && refreshOrShare({ refresh, share });
  }, 500);
};
/**
 * @description: 设置app右上角按钮
 * @param {*} setRightIcon
 * @return {*}
 */
export const setRightIcon = (buttons) => {
  if (isIOS) {
    iosSetRightIcon(buttons);
  } else if (isAndroid) {
    anSetRightIcon(buttons);
  }
};
/**
 * @description: 复制文本
 * @param {*} copyText
 * @return {*}
 */
export const copyText = ({ successMsg, errorMsg, text } = {}) => {
  if (isIOS) {
    iosCopyText({ successMsg, errorMsg, text });
  } else if (isAndroid) {
    anCopyText(text);
  }
};
/**
 * @description: 拉起小程序
 * @param {*} openMin
 * @return {*}
 */
export const openMin = ({ username, path, type } = {}) => {
  if (isIOS) {
    iosOpenMin({ username, path, type });
  } else if (isAndroid) {
    anOpenMin({ username, path, type });
  }
};
/**
 * @description: 拉起微信
 * @param {*} openWx
 * @return {*}
 */
export const openWx = () => {
  if (isIOS) {
    iosOpenWx();
  } else if (isAndroid) {
    anOpenWx();
  }
};
/**
 * @description: 获取刘海屏高度
 * @param {*} getHeaderHeight
 * @return {*}
 */
export const getHeaderHeight = () => {
  const res = isIOS ? iosGetHeaderHeight() : anGetHeaderHeight();
  const resObj = res ? JSON.parse(res) : {}
  return resObj
};
/**
 * @description: 获取手机号（掩码）
 * @param {*} getPhone
 * @return {*}
 */
export const getPhone = () => {
  let res = Cookies.get("phone");
  if (!res) {
    if (isIOS) {
      res = iosGetPhone();
    } else if (isAndroid) {
      res = window.localjs && window.localjs.getPhone();
    }
  }
  return res;
};
/**
 * @description: 设置分享信息
 * @param {*} setShareInfo
 * @return {*}
 */
export const setShareInfo = async ({
  shareObj = {},
  wxName,
  isGraphic = true,
  isMinPage = false,
  minShare = {},
} = {}) => {
  if (isApp) {
    window.getAppShareInfo = () => shareObj;
    window.isActivePage = () => (isGraphic ? 1 : 0);
  } else if (isWeixin) {
    const defaultObj = {
      link: window.location.href,
      title: "孩子王母婴商城",
      imgUrl:
        "https://cmspic-10004025.image.myqcloud.com/cdde7f80-10d9-11ea-bc86-1b2ed583a1fd_size_180x180",
    };
    const {
      title = defaultObj.title,
      imgUrl = defaultObj.imgUrl,
      link = defaultObj.link,
      thumbUrl,
      desc,
    } = shareObj;
    let isMin = await isMiniprogram();
    if (isMin) {
      // 小程序右上角分享
      wx &&
        wx.miniProgram.postMessage({
          data: {
            type: "setShareData",
            payload: {
              title,
              path: link,
              imageUrl: thumbUrl || imgUrl,
            },
          },
        });
      // 小程序分享中间页
      if (isMinPage) {
        wx &&
          wx.miniProgram.postMessage({
            data: {
              type: "setSharePageData",
              payload: {
                title,
                link,
                imgUrl: thumbUrl || imgUrl,
                ...minShare,
              },
            },
          });
      }
    } else {
      let w = new weChat(wxName);
      w.share({
        title,
        link,
        imgUrl: thumbUrl || imgUrl,
        desc,
      });
    }
  }
};
/**
 * @description: 拉起分享面板
 * @param {*} share
 * @return {*}
 */
export const share = async () => {
  let isMin = await isMiniprogram();
  if (isIOS) {
    iosSharePanel();
  } else if (isAndroid) {
    window.localjs && window.localjs.invokeAppShare();
  } else if (isMin) {
    wx &&
      wx.miniProgram.navigateTo({
        url: "/server-pages/pages/share/index",
      });
  }
};
/**
 * @description: 微信支付分
 * @param {*} getWxpayScore
 * @return {*}
 */
export const getWxpayScore = ({
  wxName,
  businessType,
  queryString,
  minType = 0,
} = {}) => {
  if (isAndroid) {
    window.localjs &&
      window.localjs.openWxPayScoreDetail(queryString, businessType, minType);
  } else if (isIOS) {
    iosWxpayScore({ businessType, queryString, minType });
  } else if (isWeixin) {
    let w = new weChat(wxName);
    w.openBusinessView({ businessType, queryString });
  }
};

export const setHeaderStyle = (headGFnParams) => {
  if (isAndroid) {
    anSetHeaderStyle(headGFnParams);
  } else if (isIOS) {
    iosSetHeaderStyle(headGFnParams);
  }
};

export const setBackBtnHide = () => {
  if (isAndroid) {
    anSetBackBtnHide();
  } else if (isIOS) {
    iosSetBackBtnHide();
  }
}

/**
 * @description: 设置页面标题，颜色，样式
 * @param {*} setHeader
 * @return {*}
 */
export const setHeader = ({
  mainColor,
  defaultBgColor,
  startBgColor,
  endBgColor,
  hideTitle,
  titleText,
  gradualBgColor,
  gradualTitleColor,
} = {}) => {
  let headGFnParams = {
    defaultBgColor,
    startBgColor,
    endBgColor,
    mainColor,
    hideTitle,
    gradualBgColor,
    gradualTitleColor,
    titleText,
  };
  onAppReady(() => {
    setHeaderStyle(headGFnParams);
  });
  window.addEventListener("pageshow", () => {
    setHeaderStyle(headGFnParams);
  });
  setHeaderStyle(headGFnParams);
  setTimeout(() => {
    setHeaderStyle(headGFnParams);
  }, 500);
};

/**
 * @description: 检查是否开启 push 通知
 * @param {*} checkPushSetting
 * @return {*}
 */
export const checkPushSetting = () => {
  if (isAndroid) {
    return anCheckPushSetting()
  } else if (isIOS) {
    return iosCheckPushSetting()
  }
}

/**
 * @description: 跳转 push 提醒权限设置
 * @param {*} openPushSetting
 * @return {*}
 */
 export const openPushSetting = () => {
  if (isAndroid) {
    return anOpenPushSetting()
  } else if (isIOS) {
    return iosOpenPushSetting()
  }
}
